module.exports = __webpack_public_path__ + "static/media/church_wood.3c3d9676.svg";